<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="108" height="130" viewBox="0 0 108 130" fill="none">
        <path opacity="0.1"
            d="M216 108C216 167.647 167.647 216 108 216C48.3532 216 0 167.647 0 108C0 48.3532 48.3532 0 108 0C167.647 0 216 48.3532 216 108Z"
            fill="url(#paint0_linear_5164_11375)" />
        <defs>
            <linearGradient id="paint0_linear_5164_11375" x1="-15.3243" y1="-2.49304e-06" x2="183.892" y2="193.378"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="white" />
                <stop offset="1" stop-color="#9D9D9D" stop-opacity="0" />
            </linearGradient>
        </defs>
    </svg>
</template>